export interface Environment {
	production: boolean;
	apiUrl: string;
	ExperienceApiUrl: string;
	ExperienceAnonymApi: string;
	ExternalApiUrl: string;
	ExternalShareApiUrl: string;
	UserManagementApiUrl: string;
	OrgManagementApiUrl: string;
	userInfoApiUrl: string;
	TagManagementApiUrl: string;
	FileShareApiUrl: string;
	FetchURLApiURL: string;

	AIEndPoint: string;

	useDummyBackend: boolean;

	username: string;
	password: string;

	appVersion: string;
	appVersionPostfix: string;
	appDataVersion: number;

	showProductionPlugins: boolean;
	showBetaPlugins: boolean;
	showAlphaPlugins: boolean;
	showPrototypePlugins: boolean;

	// Show plugins marked as internal (for example Julkaisu)
	showInternalPlugins: boolean;

	// If true, app is shut down
	serviceMode: boolean;

	serviceMessageTitle: string;
	serviceMessageText: string;

	// How often to refresh the auth token (in minutes)
	authTokenRefreshIntervalMinutes: number;

	// For how long do we refresh the token if user is inactive (in minutes)
	authTokenRefreshGapInMinutes: number;

	// HTML content for version changes modal
	versionChangesHtml: string;

	// HTML content for known issues modal
	knownIssuesHtml: string;
}

export const createEnvironment = (
	overrides: Partial<Environment> = {},
): Environment => ({
	production: true,

	showProductionPlugins: true,
	showBetaPlugins: true,
	showAlphaPlugins: false,
	showPrototypePlugins: false,

	showInternalPlugins: false,

	apiUrl: 'https://mp-backend-b6bggagsggfkd6ec.swedencentral-01.azurewebsites.net',

	ExperienceApiUrl: '/api/v1/ExperienceApi',
	ExperienceAnonymApi: '/api/v1/ExperienceAnonymApi',
	ExternalApiUrl: '/api/v1/ExternalItems',
	ExternalShareApiUrl: '/api/v1/ExperienceShare',
	UserManagementApiUrl: '/api/v1/MpUserManager',
	OrgManagementApiUrl: '/api/v1/OrganizationManager',
	userInfoApiUrl: '/api/v1/UserInfoEndpoint',
	TagManagementApiUrl: '/api/v1/Tag',
	FileShareApiUrl: '/api/v1/FileShare',
	FetchURLApiURL: '/api/v1/SourceFetcher',

	AIEndPoint: '/api/v1/OpenAI',

	useDummyBackend: false,

	authTokenRefreshIntervalMinutes: 15,
	authTokenRefreshGapInMinutes: 50,

	serviceMode: false,
	serviceMessageTitle: '',
	serviceMessageText: '',

	username: '',
	password: '',

	// Version.Subversion.BuildNumber
	appVersion: '1.0.59',

	// Optional human readable string
	appVersionPostfix: 'beta 11',

	// This determines the viewer target directory - increase plugin when data structures. New version of the viewer is built and legacy-exports will use their old viewer versions.
	appDataVersion: 4,

	versionChangesHtml: `
		
		<ul>
			<li>Tietoturvapäivityksiä.</li>
			<li>Yleisiä käytettävyysparannuksia.</li>
		</ul>
	`,

	knownIssuesHtml: `
		<ul>
			<li>Ei tiedossa olevia ongelmia.</li>
		</ul>
	`,

	...overrides,
});
